import axios from "axios";

import * as actionTypes from "./actionTypes";

export const initTopUpToken = () => {
  return {
    type: actionTypes.INIT_TopUP_Token,
    toping: true,
  };
};

export const successtopUp = (data) => {
  return {
    type: actionTypes.SUCCESS_TopUP_Token,
    toping: false,
    topUped: data,
  };
};

export const failtopUp = (error) => {
  return {
    type: actionTypes.FAIL_TopUP_Token,
    toping: false,
    error: error,
  };
};

export const topUpToken = (amount) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  const data = {
    amount: amount,
    description: "pcari topup",
    payment_method: "fpx",
  };
  return (dipatch) => {
    dipatch(initTopUpToken());
    axios
      .post("payments/topup", data, config)
      .then((response) => {
        dipatch(successtopUp(response.data));
      })
      .catch((error) => {
        dipatch(failtopUp(error));
      });
  };
};
